import { AppLockOptions } from './app-lock-options.model';
import { AppLockUserEnabledOptions } from './app-lock-user-enabled-options.model';

export class AppLock {
  /**
   * The bundle identifier of the application.
   */
  public identifier: string;

  /**
   * The Options dictionary, if present, can contain the following keys (in iOS 7.0 and later).
   */
  options: AppLockOptions;

  /**
   * The UserEnabledOptions dictionary, if present, can contain the following keys (in iOS 7.0 and later):
   */
  userEnabledOptions: AppLockUserEnabledOptions;

  constructor() {
    this.options = new AppLockOptions();
    this.userEnabledOptions = new AppLockUserEnabledOptions();
  }
}
